var BreakdownComponent = (function () {
    function BreakdownComponent() {
        this.templateUrl = 'breakdown.html';
        this.controllerAs = 'vm';
        this.controller = BreakdownController;
    }
    return BreakdownComponent;
}());

//# sourceMappingURL=breakdownComponent.js.map
